module.exports = __webpack_public_path__ + "img/factura_cancelar.274ddb43.png";